import React, { Component } from 'react'

import img1 from '../../../static/images/payment-banner.jpg'
import product3 from '../../../static/images/product-3.png'

import plat1 from '../../../static/images/payment-plat1.png'
import payment1 from '../../../static/images/payment1.png'
import payment2 from '../../../static/images/payment2.png'
import payCode1 from '../../../static/images/pay-icon-code1.png'
import arrow from '../../../static/images/arrow-right.png'

import unattended1 from '../../../static/images/unattended1.png'

import iconPayTips from '../../../static/images/icon-pay-tips.png'

import payService from '../../../static/images/pay-service.png'
import twoArrow from '../../../static/images/two-arrow.png'
import iconSelect from '../../../static/images/icon-select.png'

import aggregation from '../../../static/images/juhema.png'



import './index.less';
class payment extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
      componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'payment-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
            <div style={{ width: '100%' }}>
                 <iframe 
                 title="payment-static"
                 src={`${process.env.PUBLIC_URL}/static/payment/payment.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container unattended-container payment-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">悦喵聚合支付中台</div>
            //                     <div className="banner-top-tips">深度赋能商户 & 企业数字化升级，为客户提供多渠道、多场景金融级的聚合支付服务。</div>
            //                     <div className="banner-top-tips">该产品由-<span style={{ color: '#D1001C'}}>联拓数科小精灵支付</span>专业打造</div>
            //                     <div className="banner-top-btn">立即咨询</div>
            //                 </div>
                            
            //             </div>
                        
            //         </div>
            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">金融级的聚合支付平台</div>
            //         <div className="payment-platform">
            //             <div className="payment-platform-left">
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">...</div>
            //             </div>
            //             <img className="payment-platform-img" src={plat1} alt="" />
            //             <div className="payment-platform-left payment-platform-right">
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">支付宝支付运营</div>
            //                 <div className="payment-type">...</div>
            //                 <div className="payment-type">门店智能收银端</div>
            //             </div>
            //         </div>
            //         <div className="payment-platform-bottom">
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">支付宝支付运营</div>
            //             <div className="payment-type">...</div>
            //         </div>
            //     </div>

            //     <div className="common-block-home product-page customer-page">
            //         <div className="common-block-home-title">全渠道聚合支付接入</div>
            //         <div className="common-block-home-tips-payment">一个平台完成支付宝、微信支付、银联、翼支付等所有渠道的交易和账务管理，目前已接入国内主流支付通道20多家，并已对接&服务港、澳市场，率先对接国内主流数字人民币服务并上线</div>
            //         <div className="payment-type-content">
            //             <div className="payment-type-content-left">
            //                 <div className="bank-num-content">
            //                     <div className="bank-num">20<span className="span-more">+</span></div>
            //                     <div className="bank-tips">中外资金金融机构</div>
            //                 </div>
            //                 <div className="bank-num-content">
            //                     <div className="bank-num">2<span className="span-max">大</span></div>
            //                     <div className="bank-tips">支付国际化服务</div>
            //                 </div>
            //             </div>
            //             <div className="common-block-product common-customer">
            //                 {
            //                     customerList && customerList.map((item) => (
            //                         <div className="customer-detail-img">
            //                             <img className="img-style" src={item.img} alt="" />
            //                         </div>
            //                     ))
            //                 }

            //             </div>
            //         </div>
                    
                   
            //     </div>


            //     <div className="common-block-home advantage-common-block-home" style={{background: '#f7f7f7'}}>
            //         <div className="common-block-home-title">商户快速进件，缩短周期快速开通支付</div>

            //         <div className="advantage-detail-payment">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">升级改造成本低</div>
            //                     <div className="advantage-detail-left-tips"><img className="icon-img" src={iconPayTips} alt="" />提供快速进件模板</div>
            //                     <div className="advantage-detail-left-tips"><img className="icon-img" src={iconPayTips} alt="" />专员一对一的进行服务</div>
            //                     <div className="advantage-detail-left-title margin-top">小程序自助进件</div>
            //                     <div className="advantage-detail-left-tips"><img className="icon-img" src={iconPayTips} alt="" />快速收集商户资料</div>
            //                     <div className="advantage-detail-left-tips"><img className="icon-img" src={iconPayTips} alt="" />助力小微商高效开通支付</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={payment1} alt="" />
            //                 </div>
            //             </div>
                        
            //         </div>

            //     </div>

                
            //     <div className="common-block-home">
            //         <div className="common-block-home-title">系统运营稳定且高可用，灵活适配业务且高机动</div>
            //         <div className="member-detail-service">
            //             <img className="member-img-style" src={payment2} alt="" />
            //         </div>
            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">全场景聚合支付介入</div>
            //         <div className="common-block-product">
            //             <div className="store-model payment-store-model">
            //                 <div className="store-model-title">系统运行高可用</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />7*24小时监控及支持</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />阿里云&华为云保障高可用</div>
            //             </div>
            //             <div className="store-model payment-store-model">
            //                 <div className="store-model-title">系统架构高可用</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />冗余部署保障系统高可用</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />分布式架构保障服务高可用</div>

            //             </div>
            //             <div className="store-model payment-store-model">
            //                 <div className="store-model-title">系统配置高机动</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />多年的支付经验沉淀灵活配置</div>
            //                 <div className="store-model-tips"><img className="member-img-style" src={iconSelect} alt="" />多年的支付场景优化</div>
            //             </div>
            //         </div>
            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">多码合一，提升顾客消费体验及门店运营效率</div>
            //         <div className="aggregation-code">
            //             <div className="aggregation-code-left">
            //                 <div className="left-top-content">
            //                     <img className="member-img-style" src={payCode1} alt="" />
            //                     复杂流程
            //                 </div>
            //                 <div className="left-bottom-content">
            //                     <div className="left-list">会员码</div>
            //                     <div className="left-list">优惠券码</div>
            //                     <div className="left-list">支付码</div>
            //                 </div>
            //             </div>
            //             <div className="code-center-img">
            //                 <div className="more-code">
            //                     <img className="code-img-style" src={arrow} alt="" />
            //                     <div className="more-code-tips">多码合一</div>
            //                 </div>
            //                 <div className="code-content-img">
            //                     <img className="code-img" src={aggregation} alt="" />
            //                     <div className="code-img-tips">聚合码</div>
            //                 </div>
            //                 <img className="code-arrow-right" src={arrow} alt="" />
            //             </div>
            //             <div className="aggregation-code-left">
            //                 <div className="left-top-content">
            //                     <img className="member-img-style" src={payCode1} alt="" />
            //                     业务价值
            //                 </div>
            //                 <div className="left-bottom-content">
            //                     <div className="left-list left-list-1">用户体验提升</div>
            //                     <div className="left-list left-list-1">商家效率提升</div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>

            //     <div className="common-block-home payment-direct">
            //         <div className="common-block-home-title">间直连支付快速切换，增加商户可运营通道</div>
            //         <div className="aggregation-code">
            //             <div className="code-center-img">
                            
            //                 <div className="code-content-img">
            //                     <img className="code-img" src={payCode1} alt="" />
            //                     <div className="code-img-tips">商户</div>
            //                 </div>
            //                 <img className="code-arrow-right" src={arrow} alt="" />
            //             </div>
            //             <div className="aggregation-code-left">
            //                 <div className="left-top-content">
            //                     <img className="member-img-style" src={payCode1} alt="" />
            //                     支付
            //                 </div>
            //                 <div className="left-bottom-content">
            //                     <div className="left-list">直连支付通道</div>
            //                     <div className="more-code">
            //                         <img className="code-img-style" src={twoArrow} alt="" />
            //                         <div className="more-code-tips">快速切换</div>
            //                     </div>
            //                     <div className="left-list">间连支付通道</div>
            //                 </div>
            //             </div>
            //             <img className="code-arrow-right" src={arrow} alt="" />
            //             <div className="aggregation-code-left">
            //                 <div className="left-top-content">
            //                     <img className="member-img-style" src={payCode1} alt="" />
            //                     业务价值
            //                 </div>
            //                 <div className="left-bottom-content">
            //                     <div className="left-list left-list-1">活动档期快速适配</div>
            //                     <div className="left-list left-list-1">无须二次开发改造</div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">支付+服务，打造全交易链路闭环</div>
            //         <div className="common-block-home-tips-payment">基于移动支付，每一笔交易成功后（支付成功页）的流量曝光，助力引导顾客入会、开票、发券、推企微、消息触达等，快速进行会员转化，为后续消费转化打下基础</div>
            //         <div className="member-detail-service">
            //             <img className="member-img-style" style={{height: '380px'}} src={payService} alt="" />
            //         </div>
            //     </div>

            //     <div className="common-block-home unattended-first">
            //         <div className="common-block-home-title">配套硬件产品，升级门店购物体验</div>
            //         <div className="common-block-product">
            //             <div className="store-model">
            //                 <div className="store-model-tips">自助大屏结算POS</div>
            //                 <img className="unattended-img-style" src={unattended1} alt="" />
            //                 <div className="store-model-tips-pos">支持扫码录入商品，展示价格、优惠信息，会员积分、打印小票等业务场景。顾客通过自助大屏快速扫码/刷脸结算，实现购物体验及结算效率提升</div>
            //                 <div className="store-model-title">我是支付服务商</div>
            //                 <div className="store-model-tips">我想代理悦喵支付业务</div>
            //                 <div className="call-btn">联系我们</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-tips">店员移动版MPOS</div>
            //                 <img className="unattended-img-style" src={unattended1} alt="" />
            //                 <div className="store-model-tips-pos">支持商品的扫码、订单结算、电子小票、会员积分、导购提成统计等业务场景。门店导购通过Mpos实现移动收银、快速收银，在货架周围即可完成一次次销售闭环</div>
            //                 <div className="store-model-title">我是合作商户</div>
            //                 <div className="store-model-tips">我想对接悦喵支付业务</div>
            //                 <div className="call-btn">联系我们</div>
            //             </div>
            //         </div>
            //     </div>
               


                
            // </div >
        )
    }
}


export default payment